import {
  useCallback, useEffect, useMemo, useRef,
} from 'react'
import { Form, Formik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'
import { SingleProductGroup } from '@src/components/SingleProductGroup/SingleProductGroup'
import { selectUserProductGroup } from '@src/store/ducks/user/selectors'

import { getProductGroup, newProductGroup } from '@src/store/ducks/user/thunks'
import { AppDispatch } from '@src/store/store'
import style from '@src/pages/ProductGroup/ProductGroup.module.scss'

export const ProductGroup = () => {
  const formRef = useRef<any>(null)
  const dispatch = useDispatch<AppDispatch>()
  const productsGroup = useSelector(selectUserProductGroup)

  useEffect(() => {
    dispatch(getProductGroup())
  }, [dispatch])

  const initialValues = useMemo(() => {
    const tmp: any = {}

    productsGroup.forEach((group) => {
      tmp[group.id] = group.isActive
    })
    return tmp
  }, [productsGroup])

  const handleChange = useCallback((id: number, value: boolean) => {
    const limit = 3
    const counterTrue = Object.values(formRef.current.values).filter((item) => item).length

    if ((counterTrue < limit && value) || !value) {
      formRef.current.setFieldValue(id.toString(), value)
      dispatch(newProductGroup(id))
    }
  }, [dispatch])

  return (
    <div className={style.productGroup}>
      <div className={style.productGroup_description}>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Gravida euismod nisl sit vitae. Augue massa, neque, sed at cursus arcu. Amet, arcu
        mi, dictumst urna, quis. Diam massa enim risus mollis eget. Interdum in vitae nunc ipsum consectetur. Sit elementum elit sed lobortis. Magna
        tellus malesuada sed dolor metus.
      </div>
      <div className={style.productGroup_container}>
        <Formik
          innerRef={formRef}
          initialValues={initialValues}
          onSubmit={() => {}}
          enableReinitialize
        >
          {({ values }) => (
            <Form>
              {productsGroup.map((group) => (
                <SingleProductGroup
                  key={group.id}
                  label={<div>{group.title}</div>}
                  checked={values[group.id]}
                  disabled={Object.values(values).filter((item) => item).length >= 3 && !values[group.id]}
                  onChange={(value) => { handleChange(group.id, value.target.checked) }}
                />
              ))}
            </Form>
          )}
        </Formik>

      </div>
    </div>
  )
}
